import React, {FC} from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import {Card, CardContent} from "framework7-react";
import {useTranslation} from "react-i18next";

interface ChartsTestProps {
    currency?: string
}
const ChartsTest: FC <ChartsTestProps> = ({currency}) => {
    const {t} = useTranslation();
    const series = [
        {
            name: 'Commission',
            data: [1000, 4001, 3500, 5100, 4900, 6002, 6009],
        },
        {
            name: 'GGR',
            data: [6009, 3000, 3500, 4600, 4900, 5000, 5500],
        },
    ];
    const options: ApexOptions = {
        chart: {
            type: 'area',
            height: 250,
            stacked: true,
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: true,
                }
            }
        },

        fill: {
            type: ['gradient', 'solid', 'pattern', 'image']
        },
        title: {
            text: t("dashboard.salesThisMonth"),
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        },
    };

    return(
        <Card>
            <CardContent>
                <Chart options={options} series={series} type="line" height={250} />
            </CardContent>
        </Card>
    );
};

export default ChartsTest;
